import PropTypes from 'prop-types';
import MaterialFormElement from './material_form_element';

export class MaterialSelect extends MaterialFormElement {
  static propTypes = {
    includeInputHelper: PropTypes.bool
  }

  static defaultProps = {
    includeInputHelper: false,
    className: 'select optional',
    labelClassName: 'fg-label col-form-label',
    wrapperClassName: 'fg-line select',
    groupClassName: 'form-group fg-float select',
    type: 'select'
  }

  renderChildren = () => {
    return [
      this.renderWrapper(
        [
          this.renderLabel(),
          this.renderInputGroup(
            [
              this.renderInput(),
              this.renderInputHelper()
            ]
          ),
          this.renderIcon(),
          this.renderHelp()
        ]
      )
    ]
  }
}
